import axios from "axios";
import { API_HOST } from "../variables";

export const getProfile = () => {
    return axios.get(`${API_HOST}/v1/auth/me`);
};
